// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"b342ba29","264":"b342ba29","577":"9c6343f3","631":"b342ba29"}[chunkId] + ".chunk.css";
};